module.exports = __webpack_public_path__ + "img/social-media.fa50d20f.png";